import React from 'react';
import PropTypes from 'prop-types';

import { Field, connect } from 'formik';

import BirthDateCommon from '../../../CommonV2/BirthDate';

/**
 * FieldInput
 * @param {*} param0
 */
const FieldBirthDate = ({ code, disabled, existError, showError, validate, handleBlur, param }) => (
  <Field
    component={BirthDateCommon}
    name={code}
    disabled={disabled}
    existError={existError}
    showError={showError}
    validate={validate}
    eventEmitter={v => handleBlur(v)}
    param={param}
  />
);

FieldBirthDate.propTypes = {
  code: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  validate: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  param: PropTypes.shape({
    min: PropTypes.string,
    max: PropTypes.string,
    methodCalculateAge: PropTypes.string,
  }),
};
FieldBirthDate.defaultProps = {
  disabled: false,
  param: {},
};

export default connect(FieldBirthDate);
